import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const NextMatcWidgetAsyncComponent = AsyncComponent(async () => import('./next-match-widget' /* webpackChunkName: "next-match-widget" */ ));

export const NextMatchWidgetAsync = (props) => {
  return <NextMatcWidgetAsyncComponent {...props}/>

  //Add Suspense only if needed
  // <React.Suspense fallback={<div/>}>
  //   <TemplateWidgetAsyncComponent {...props}/>
  // </React.Suspense>
};
